import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'
import { EXTERNAL_PLATFORMS_FETCH_BEGIN } from './action-types'
import { fetchExternalPlatforms } from './api'

export default function* root() {
  yield takeLatestApiCall(EXTERNAL_PLATFORMS_FETCH_BEGIN, fetchExternalPlatforms)
}
